import { Navigate } from 'react-router-dom'

import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

interface CommunitiesFeatureFlagGuardProps {
  children: React.ReactNode
}

const isFeatureEnabled = (data: {
  features?: { featuresConnection?: { nodes?: Array<{ name: string; enabled: boolean }> } }
}): boolean => {
  return (
    data.features?.featuresConnection?.nodes?.find(
      (feature) => feature.name === 'dev_communities_page'
    )?.enabled ?? false
  )
}

const CommunitiesFeatureFlagGuard = ({ children }: CommunitiesFeatureFlagGuardProps) => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const { data, loading } = useQuery(FeatureFlagAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      companyId: company.id,
      featureNames: ['dev_communities_page'],
    },
  })

  if (data && !isFeatureEnabled(data)) {
    return <Navigate replace to={navigation.dashboard.fullPath()} />
  }

  if (loading || !data) {
    return <Loading />
  }

  if (isFeatureEnabled(data)) {
    return <>{children}</>
  }

  return <Navigate replace to={navigation.dashboard.fullPath()} />
}

export default CommunitiesFeatureFlagGuard
